import axios from "axios";

export const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

const t = () => localStorage.getItem("ehu_token");

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((c) => {
  const tok = t();
  if (tok) c.headers.Authorization = `Bearer ${tok}`;
  return c;
});

export const login = (email, password) => api.post("/auth/login", { email, password });
export const signup = (payload) => api.post("/auth/signup", payload);
export const changePassword = (current_password, new_password) => api.post("/auth/change-password", { current_password, new_password });
export const me = () => api.get("/auth/me");

export const reg = {
  list: (name) => api.get(`/reg/${name}`),
  create: (name, data) => api.post(`/reg/${name}`, data),
  patch: (name, id, data) => api.patch(`/reg/${name}/${id}`, data),
  del: (name, id) => api.delete(`/reg/${name}/${id}`),
};

export const dashboard = () => api.get("/dashboard");
export const radarSweep = () => api.post("/compliance/sweep");
export const radarStatus = () => api.get("/compliance/radar");
export const adoptRes = (rid) => api.post(`/resolutions/${rid}/adopt`);
export const executeInstrument = (iid, acknowledgment) =>
  api.post(`/instruments/${iid}/execute`, { acknowledgment });
export const integrityScan = () => api.get("/integrity/scan");
export const genMinutes = (mid) => api.post(`/meetings/${mid}/minutes`);
export const libraryList = () => api.get("/library/instruments");
export const libraryGet = (id) => api.get(`/library/instruments/${id}`);
export const draftsList = () => api.get("/drafts");
export const draftGet = (id) => api.get(`/drafts/${id}`);
export const draftCreate = (payload) => api.post("/drafts", payload);
export const draftSave = (id, data) => api.patch(`/drafts/${id}`, data);
export const draftDel = (id) => api.delete(`/drafts/${id}`);
export const draftComment = (id, text) => api.post(`/drafts/${id}/comments`, { text });
export const exportDocx = (payload) =>
  api.post("/export/docx", payload, { responseType: "blob" });
export const exportPdf = (payload) =>
  api.post("/export/pdf", payload, { responseType: "blob" });
export const backupExport = () => api.get("/backup/export");
export const backupRestore = (payload) => api.post("/backup/restore", payload);
export const listUsers = () => api.get("/users");
export const approveUser = (uid) => api.post(`/users/${uid}/approve`);
export const denyUser = (uid, note) => api.post(`/users/${uid}/deny`, { note });
export const admin = {
  accessRequests: (status = "") => api.get("/users"),
  requestInfo: (uid, note) => api.post(`/users/${uid}/request-info`, { note }),
  suspend: (uid) => api.post(`/users/${uid}/suspend`),
  reactivate: (uid) => api.post(`/users/${uid}/reactivate`),
  revokeSessions: (uid) => api.post(`/users/${uid}/revoke-sessions`),
  issueTempPassword: (uid) => api.post(`/users/${uid}/issue-temp-password`),
  setRole: (uid, payload) => api.post(`/users/${uid}/set-role`, payload),
  portalRoles: () => api.get("/admin/portal-roles"),
  smithReport: () => api.get("/admin/trustee-smith-report"),
  contact: () => api.get("/admin/contact"),
};
export const courses = () => api.get("/academy/courses");
export const courseDetail = (cid) => api.get(`/academy/courses/${cid}`);
export const lessonDetail = (lid) => api.get(`/academy/lessons/${lid}`);
export const submitQuiz = (lid, payload) => api.post(`/academy/lessons/${lid}/submit`,
  Array.isArray(payload) ? { answers: payload } : payload);
export const courseCertificate = (cid) => api.get(`/academy/courses/${cid}/certificate`, { responseType: "blob" });
export const aiEnrichLesson = (lid, mode = "extras", model = "claude") => api.post(`/academy/lessons/${lid}/ai-enrich`, { mode, model });
export const academyStatus = () => api.get("/academy/status");
export const academyPrograms = () => api.get("/academy/programs");
export const academyProgram = (pid) => api.get(`/academy/programs/${pid}`);
export const academyHome = () => api.get("/academy/home");
export const academyRoles = () => api.get("/academy/roles");
export const academyBadges = () => api.get("/academy/badges");
export const academyTranscript = () => api.get("/academy/transcript");
export const academyTranscriptIssue = (issued_to) => api.post("/academy/transcript/issue", { issued_to });
export const academyTranscriptHistory = () => api.get("/academy/transcript/mine");
export const academyTranscriptVerify = (code) => api.get(`/academy/transcript/verify/${code}`);
export const academyTranscriptRevoke = (tid, reason) => api.post(`/academy/transcript/${tid}/revoke`, { reason });
export const academyPracticumSubmit = (payload) => api.post("/academy/practicum/submit", payload);
export const academyPracticumMine = () => api.get("/academy/practicum/mine");
export const academyPracticumInbox = () => api.get("/academy/practicum/inbox");
export const academyPracticumDecision = (sid, payload) => api.post(`/academy/practicum/${sid}/decision`, payload);
export const academyIntegrityReport = (payload) => api.post("/academy/integrity/report", payload);
export const academyIntegrityCases = () => api.get("/academy/integrity/cases");
export const academyIntegrityAction = (cid, payload) => api.post(`/academy/integrity/${cid}/action`, payload);
export const academyQaSnapshot = () => api.get("/academy/qa/snapshot");
export const academyAnalytics = () => api.get("/academy/analytics");
export const academyAnnouncements = () => api.get("/academy/announcements");
export const academyAnnouncementCreate = (payload) => api.post("/academy/announcements", payload);
export const academyAnnouncementDelete = (aid) => api.delete(`/academy/announcements/${aid}`);
export const academyPolicies = () => api.get("/academy/policies");

// ---- Infinite Banking / Policy Bank ----
export const ibc = {
  list: () => api.get("/ibc/policies"),
  get: (pid) => api.get(`/ibc/policies/${pid}`),
  create: (data) => api.post("/ibc/policies", data),
  patch: (pid, data) => api.patch(`/ibc/policies/${pid}`, data),
  del: (pid) => api.delete(`/ibc/policies/${pid}`),
  addLedger: (pid, data) => api.post(`/ibc/policies/${pid}/ledger`, data),
  addLoan: (pid, data) => api.post(`/ibc/policies/${pid}/loans`, data),
  repay: (lid, data) => api.post(`/ibc/loans/${lid}/repay`, data),
  projection: (pid, years = 30, dividend) => api.get(`/ibc/policies/${pid}/projection`, { params: { years, ...(dividend != null ? { dividend } : {}) } }),
  draft: (pid, payload) => api.post(`/ibc/policies/${pid}/draft`, payload),
};

// ---- Expanded public data + funding radar ----
export const fundingRadar = (q = "family trust") => api.get("/funding/radar", { params: { q } });
export const librarySearch = (q, groups) => api.get("/library/search", { params: { q, groups } });
export const taxResources = () => api.get("/tax-resources");
export const apexSummary = () => api.get("/apex/summary");
export const beneficiarySummary = () => api.get("/beneficiary/summary");
export const draftingStatuses = () => api.get("/drafting/statuses");
export const taxOptions = () => api.get("/tax/classifications/options");
export const taxSummary = () => api.get("/tax/summary");
export const publicData = {
  worldBank: (indicator, country = "US") => api.get("/public/world-bank", { params: { indicator, country } }),
  bls: (series_id) => api.get("/public/bls", { params: { series_id } }),
  treasuryDebt: () => api.get("/public/treasury-debt"),
  fred: (series_id) => api.get("/public/fred", { params: { series_id } }),
  sba: (q = "") => api.get("/public/sba", { params: { q } }),
  regulations: (q = "trust") => api.get("/public/regulations", { params: { q } }),
  fema: (state = "SD") => api.get("/public/fema", { params: { state } }),
  vin: (vin) => api.get("/public/vin", { params: { vin } }),
  nppes: (name, state) => api.get("/public/nppes", { params: { name, state } }),
};

// ---- Phase 1: Legacy Vault (scoped), Secure Document Vault, Reminders, Notifications, Activation, Audit ----
export const legacy = {
  list: (kind) => api.get(`/legacy/${kind}`),
  create: (kind, data) => api.post(`/legacy/${kind}`, data),
  patch: (kind, id, data) => api.patch(`/legacy/${kind}/${id}`, data),
  del: (kind, id) => api.delete(`/legacy/${kind}/${id}`),
  share: (kind, id, person) => api.post(`/legacy/${kind}/${id}/share`, person),
  unshare: (kind, id, email) => api.post(`/legacy/${kind}/${id}/unshare`, { email }),
  release: (id) => api.post(`/legacy/legacy_messages/${id}/release`),
  revoke: (id) => api.post(`/legacy/legacy_messages/${id}/revoke`),
};

export const vault = {
  list: () => api.get("/vault"),
  upload: (formData) => api.post("/vault/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }),
  patch: (id, data) => api.patch(`/vault/${id}`, data),
  share: (id, person) => api.post(`/vault/${id}/share`, person),
  unshare: (id, email) => api.post(`/vault/${id}/unshare`, { email }),
  del: (id) => api.delete(`/vault/${id}`),
  downloadUrl: (id) => `${API}/vault/${id}/download?auth=${encodeURIComponent(localStorage.getItem("ehu_token") || "")}`,
  downloadBlob: (id) => api.get(`/vault/${id}/download`, { responseType: "blob" }),
};

export const reminders = {
  list: () => api.get("/reminders"),
  create: (data) => api.post("/reminders", data),
  patch: (id, data) => api.patch(`/reminders/${id}`, data),
  del: (id) => api.delete(`/reminders/${id}`),
  run: () => api.post("/reminders/run"),
};

export const notifications = {
  list: () => api.get("/notifications"),
  read: (id) => api.post(`/notifications/${id}/read`),
  readAll: () => api.post("/notifications/read-all"),
};

export const activation = {
  mine: () => api.get("/legacy/activation/mine"),
  preview: (ownerId) => api.get(`/legacy/activation/${ownerId}/preview`),
  activate: (ownerId, confirm_password, note) => api.post(`/legacy/activation/${ownerId}/activate`, { confirm_password, note }),
  revert: (ownerId, confirm_password) => api.post(`/legacy/activation/${ownerId}/revert`, { confirm_password }),
};

// ---- Master Prompt 4: activation-safety core ----
export const mp4 = {
  disputes: () => api.get("/mp4/disputes"),
  disputeMeta: () => api.get("/mp4/disputes/meta"),
  createDispute: (data) => api.post("/mp4/disputes", data),
  patchDispute: (id, data) => api.patch(`/mp4/disputes/${id}`, data),
  delDispute: (id) => api.delete(`/mp4/disputes/${id}`),
  provenance: (kind, record_id) => api.get("/mp4/provenance", { params: { kind, record_id } }),
  simulate: (action, kind, record_id) => api.post("/mp4/simulate", { action, kind, record_id }),
  excludeFromAi: (kind, record_id, exclude) => api.post("/mp4/exclude-from-ai", { kind, record_id, exclude }),
};

// ---- MP4 Sub-Agent charters (portal services) + Final All-Phase Audit ----
export const subagents = {
  list: () => api.get("/subagents"),
  run: (id) => api.post(`/subagents/${id}/run`),
  runs: () => api.get("/subagents/runs"),
  allPhaseAudit: () => api.get("/audit/all-phase"),
  dependencyMap: () => api.get("/audit/dependency-map"),
};

// ---- Academy — living teaching content ----
export const academyRegenerateTeaching = (lid) => api.post(`/academy/lessons/${lid}/regenerate-teaching`);
export const academyTeaching = {
  start: (force = false) => api.post("/academy/teaching/generate", { force }),
  status: () => api.get("/academy/teaching/status"),
};

// ---- MP4 Tranche 3: DR/Continuity + break-glass, and UI mode ----
export const setUiMode = (mode) => api.put("/me/ui-mode", { mode });
export const dr = {
  continuity: () => api.get("/dr/continuity"),
  saveContinuity: (data) => api.put("/dr/continuity", data),
  status: () => api.get("/dr/status"),
  breakGlassList: () => api.get("/dr/break-glass"),
  breakGlassRequest: (reason, confirm_password, minutes) => api.post("/dr/break-glass/request", { reason, confirm_password, minutes }),
  breakGlassClose: (id) => api.post(`/dr/break-glass/${id}/close`),
};

export const auditTrail = (limit = 300) => api.get("/audit", { params: { limit } });

// ---- File & media storage (reusable across surfaces) ----
export const CHUNK_SIZE = 5 * 1024 * 1024;

export const media = {
  list: (context_type = "", context_id = "") => api.get("/media", { params: { context_type, context_id } }),
  get: (id) => api.get(`/media/${id}`),
  patch: (id, data) => api.patch(`/media/${id}`, data),
  share: (id, email, name) => api.post(`/media/${id}/share`, { email, name }),
  unshare: (id, email) => api.post(`/media/${id}/unshare`, { email }),
  del: (id) => api.delete(`/media/${id}`),
  setAvatar: (media_id) => api.put("/me/avatar", { media_id }),
  // Direct URL for <img>/<video>/<audio> (query-param auth; supports Range).
  url: (id) => `${API}/media/${id}/download?auth=${encodeURIComponent(localStorage.getItem("ehu_token") || "")}`,
};

// Uploads a File; picks chunked transfer for large files. onProgress(0..100).
export async function uploadMedia(file, { contextType = "library", contextId = "", visibility = "Private", caption = "", onProgress } = {}) {
  const DIRECT = 15 * 1024 * 1024;
  if (file.size <= DIRECT) {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("context_type", contextType);
    fd.append("context_id", contextId);
    fd.append("visibility", visibility);
    fd.append("caption", caption);
    const r = await api.post("/media/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => { if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100)); },
    });
    return r.data.asset;
  }
  const init = await api.post("/media/upload/init", {
    filename: file.name, content_type: file.type || "", total_size: file.size,
    context_type: contextType, context_id: contextId, visibility, caption,
  });
  const { upload_id, chunk_size } = init.data;
  const size = chunk_size || CHUNK_SIZE;
  const chunks = Math.ceil(file.size / size);
  for (let i = 0; i < chunks; i++) {
    const blob = file.slice(i * size, Math.min((i + 1) * size, file.size));
    await api.put(`/media/upload/${upload_id}/chunk?index=${i}`, blob, {
      headers: { "Content-Type": "application/octet-stream" },
    });
    if (onProgress) onProgress(Math.round(((i + 1) / chunks) * 100));
  }
  const done = await api.post(`/media/upload/${upload_id}/complete`);
  return done.data.asset;
}

// ---- Phase 2A: Drafting Foundation (question-first intake + jurisdiction) ----
export const drafting = {
  catalog: () => api.get("/drafting/catalog"),
  jurisdictions: () => api.get("/drafting/jurisdictions"),
  addJurisdiction: (data) => api.post("/drafting/jurisdictions", data),
  sessions: () => api.get("/drafting/sessions"),
  createSession: (instrument, title) => api.post("/drafting/sessions", { instrument, title }),
  getSession: (sid) => api.get(`/drafting/sessions/${sid}`),
  delSession: (sid) => api.delete(`/drafting/sessions/${sid}`),
  questions: (sid) => api.get(`/drafting/sessions/${sid}/questions`),
  save: (sid, payload) => api.patch(`/drafting/sessions/${sid}`, payload),
  readiness: (sid) => api.get(`/drafting/sessions/${sid}/readiness`),
  explain: (sid, key, model = "claude") => api.post(`/drafting/sessions/${sid}/explain`, { key, model }),
  generate: (sid) => api.post(`/drafting/sessions/${sid}/generate`),
  promote: (cid) => api.post(`/drafting/collective/${cid}/promote`),
  clauses: () => api.get("/drafting/clauses"),
  addClause: (data) => api.post("/drafting/clauses", data),
  bookkeepingTemplates: () => api.get("/drafting/bookkeeping/templates"),
  root: () => api.get("/drafting/root"),
  collective: () => api.get("/drafting/collective"),
  createRoot: (data) => api.post("/drafting/root", data),
  createCollective: (data) => api.post("/drafting/collective", data),
  editCollective: (cid, data) => api.patch(`/drafting/collective/${cid}`, data),
};

// ---- Phase 3: Advanced Integrations ----
export const estateValue = () => api.get("/estate/value");
export const entityHub = {
  types: () => api.get("/entities-hub/types"),
  list: () => api.get("/entities-hub"),
  create: (data) => api.post("/entities-hub", data),
  patch: (id, data) => api.patch(`/entities-hub/${id}`, data),
  del: (id) => api.delete(`/entities-hub/${id}`),
};
export const complianceCalendar = () => api.get("/compliance-calendar");
export const timeCapsules = {
  list: () => api.get("/time-capsules"),
  create: (data) => api.post("/time-capsules", data),
  patch: (id, data) => api.patch(`/time-capsules/${id}`, data),
  del: (id) => api.delete(`/time-capsules/${id}`),
  run: () => api.post("/time-capsules/run"),
};
export const signatures = {
  list: () => api.get("/signatures"),
  create: (data) => api.post("/signatures", data),
  setStatus: (id, status) => api.patch(`/signatures/${id}/status`, { status }),
  statuses: () => api.get("/signatures/statuses"),
};
export const estateAssistant = (question, model = "claude") => api.post("/ai/estate-assistant", { question, model });


export function saveBlob(blob, filename) {  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}
